/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* ExclusionAddresses is one org-owned uploaded address-exclusion file.
*/
export class V1ExclusionAddresses {
    /**
    * Unique identifier of the exclusion-address file
    */
    'id'?: string;
    /**
    * Owning organization's ID
    */
    'orgId'?: string;
    /**
    * Original uploaded file name
    */
    'fileName'?: string;
    /**
    * Number of address records in the uploaded file
    */
    'recordCount'?: number;
    /**
    * How the file is attached: \"subscription\" (directly) or \"pixel\" (inherited from a pixel-level attachment)
    */
    'attachmentType'?: string;
    /**
    * When the file was uploaded
    */
    'created'?: Date;
    /**
    * Geocode lifecycle: \"PROCESSING\" (set at upload), \"READY\" (geocoded), or \"FAILED\"
    */
    'status'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "fileName",
            "baseName": "file_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "recordCount",
            "baseName": "record_count",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "attachmentType",
            "baseName": "attachment_type",
            "type": "string",
            "format": ""
        },
        {
            "name": "created",
            "baseName": "created",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1ExclusionAddresses.attributeTypeMap;
    }

    public constructor() {
    }
}

